import React, { useEffect, useState } from "react";
import { useNavigate } from "react-router-dom";
import RobitoLogo from "../components/AppLogo";
import { apiPostAuth } from "../utils/api";

function TopBar() {
  const navigate = useNavigate();
  return (
    <header className="header">
      <div className="left">
        <button
          className="icon-btn"
          onClick={() => navigate(-1)}
          aria-label="Back"
          title="Back"
          style={{ color: "white" }}
        >
          ‹
        </button>
      </div>
      <div className="logo">
        <RobitoLogo />
      </div>
      <div className="right" />
    </header>
  );
}

export default function AccountSetting() {
  const [loading, setLoading] = useState(true);
  const [loadError, setLoadError] = useState("");

  // Profile info
  const [name, setName] = useState("-");
  const [email, setEmail] = useState("-");

  // Password fields
  const [oldPassword, setOldPassword] = useState("");
  const [newPassword, setNewPassword] = useState("");
  const [confirmNew, setConfirmNew] = useState("");

  // Show/hide toggles
  const [showOld, setShowOld] = useState(false);
  const [showNew, setShowNew] = useState(false);
  const [showConfirm, setShowConfirm] = useState(false);

  // UI states
  const [changing, setChanging] = useState(false);
  const [msg, setMsg] = useState("");
  const [err, setErr] = useState("");

  useEffect(() => {
    let cancelled = false;

    async function load() {
      setLoading(true);
      setLoadError("");
      try {
        const res = await apiPostAuth("/account/setting.php", {});
        const ok = res?.result === 1;
        const data = res?.data || res;

        if (ok && data) {
          if (!cancelled) {
            setName(data.name || "-");
            setEmail(data.email || "-");
          }
        } else {
          if (!cancelled) setLoadError("Gagal memuat data akun.");
        }
      } catch {
        if (!cancelled) setLoadError("Tidak dapat memuat data akun saat ini.");
      } finally {
        if (!cancelled) setLoading(false);
      }
    }

    load();
    return () => {
      cancelled = true;
    };
  }, []);

  useEffect(() => {
    if (!msg && !err) return;
    const t = setTimeout(() => {
      setMsg("");
      setErr("");
    }, 3000);
    return () => clearTimeout(t);
  }, [msg, err]);

  const newLenValid = newPassword.length >= 8;
  const confirmValid = newPassword === confirmNew && confirmNew.length > 0;
  const notSameAsOld = newPassword && oldPassword && newPassword !== oldPassword;
  const formValid = newLenValid && confirmValid && notSameAsOld && !!oldPassword;

  const onSubmit = async () => {
    if (!formValid || changing) return;
    setChanging(true);
    setMsg("");
    setErr("");

    try {
      const res = await apiPostAuth("/account/change_password.php", {
        old_password: oldPassword,
        new_password: newPassword,
      });

      if (res?.result === 1) {
        setMsg("Kata sandi berhasil diperbarui.");
        setOldPassword("");
        setNewPassword("");
        setConfirmNew("");
      } else {
        setErr("Kata sandi lama salah");
      }
    } catch {
      setErr("Tidak dapat mengubah kata sandi saat ini.");
    } finally {
      setChanging(false);
    }
  };

  return (
    <div className="app-shell account-settings">
      <TopBar />

      <main className="main">
        <h2 style={{ margin: "0 0 8px" }}>Account Settings</h2>
        <p className="small" style={{ marginTop: 0 }}>
          Lihat informasi akun kamu dan ubah kata sandi.
        </p>

        {(msg || err) && (
          <div
            className={
              "site-message " +
              (err ? "site-message-error" : msg ? "site-message-success" : "") +
              " show"
            }
            style={{ marginBottom: 12 }}
          >
            {err || msg}
          </div>
        )}

        {loading ? (
          <div className="site-message">Memuat pengaturan akun…</div>
        ) : loadError ? (
          <div className="site-message site-message-error">{loadError}</div>
        ) : (
          <>
            <section className="site-card">
              <h3 className="site-section-title">Profil</h3>

              <div className="site-field">
                <label className="site-label">Nama</label>
                <div className="site-static">{name || "-"}</div>
              </div>

              <div className="site-field">
                <label className="site-label">Email</label>
                <div className="site-static">{email || "-"}</div>
              </div>
            </section>

            <section className="site-card">
              <h3 className="site-section-title">Ubah Kata Sandi</h3>
              <p className="site-hint">
                Gunakan minimal 8 karakter. Untuk keamanan, jangan gunakan kata sandi yang sama dengan yang lama.
              </p>

              {/* Old password */}
              <div className="site-field password-field">
                <label className="site-label">Kata Sandi Lama</label>
                <div className="input-with-icon">
                  <input
                    className="site-input"
                    type={showOld ? "text" : "password"}
                    value={oldPassword}
                    onChange={(e) => setOldPassword(e.target.value)}
                    placeholder="Masukkan kata sandi lama"
                    autoComplete="current-password"
                  />
                  <button
                    type="button"
                    className="view-btn"
                    onClick={() => setShowOld(!showOld)}
                    title={showOld ? "Sembunyikan" : "Tampilkan"}
                  >
                    {showOld ? "Sembunyikan" : "Tampilkan"}
                  </button>
                </div>
              </div>

              {/* New password */}
              <div className="site-field password-field">
                <label className="site-label">Kata Sandi Baru</label>
                <div className="input-with-icon">
                  <input
                    className="site-input"
                    type={showNew ? "text" : "password"}
                    value={newPassword}
                    onChange={(e) => setNewPassword(e.target.value)}
                    placeholder="Minimal 8 karakter"
                    autoComplete="new-password"
                  />
                  <button
                    type="button"
                    className="view-btn"
                    onClick={() => setShowNew(!showNew)}
                    title={showNew ? "Sembunyikan" : "Tampilkan"}
                  >
                    {showNew ? "Sembunyikan" : "Tampilkan"}
                  </button>
                </div>
                {!newLenValid && newPassword.length > 0 && (
                  <div className="site-error">Minimal 8 karakter.</div>
                )}
                {oldPassword && newPassword && !notSameAsOld && (
                  <div className="site-error">Kata sandi baru tidak boleh sama dengan yang lama.</div>
                )}
              </div>

              {/* Confirm password */}
              <div className="site-field password-field">
                <label className="site-label">Konfirmasi Kata Sandi Baru</label>
                <div className="input-with-icon">
                  <input
                    className="site-input"
                    type={showConfirm ? "text" : "password"}
                    value={confirmNew}
                    onChange={(e) => setConfirmNew(e.target.value)}
                    placeholder="Ketik ulang kata sandi baru"
                    autoComplete="new-password"
                  />
                  <button
                    type="button"
                    className="view-btn"
                    onClick={() => setShowConfirm(!showConfirm)}
                    title={showConfirm ? "Sembunyikan" : "Tampilkan"}
                  >
                    {showConfirm ? "Sembunyikan" : "Tampilkan"}
                  </button>
                </div>
                {confirmNew.length > 0 && !confirmValid && (
                  <div className="site-error">Konfirmasi tidak cocok.</div>
                )}
              </div>

              <div className="site-actions">
                <button
                  className="site-btn"
                  onClick={onSubmit}
                  disabled={!formValid || changing}
                >
                  {changing ? "Menyimpan…" : "Simpan Perubahan"}
                </button>
              </div>
            </section>
          </>
        )}
      </main>
    </div>
  );
}
